import Link from "next/link";
import "react-loading-skeleton/dist/skeleton.css";
import { ComponentsBaseProps } from "../../types";
import { PlatformsIcon } from "../../non-editable/core";

import styles from "./sticky-navbar.module.scss";
import { FieldParams } from "../../constants";
import { handleFormatStyleString } from "../../utils/common";

export interface StickyNavbar1Props extends ComponentsBaseProps {
  vendorFullAdress: FieldParams;
  vendorPhone1: FieldParams;
  vendorWhatsAppPhone1: FieldParams;
  linkGPS: FieldParams;
  visible?: boolean;
  showWhatsapp?: FieldParams;
  showPhone?: FieldParams;
}

export const StickyNavbar1 = (props: StickyNavbar1Props) => {
  //@ts-ignore
  if (props && (props.visible == false || props.visible?.value == false)) {
    return <div />;
  }

  const showWhatsapp = props.showWhatsapp?.value ?? true;
  const showPhone = props.showWhatsapp?.value ?? false;

  const whatsappStore1 =
    props?.vendorWhatsAppPhone1?.value ?? props?.vendorWhatsAppPhone1;
  const phoneStore1 = props?.vendorPhone1?.value ?? props?.vendorPhone1;

  return (
    <>
      {props && props.styles && props.styles.value && (
        <style>
          {handleFormatStyleString(props.styles.value as string, props.id)}
        </style>
      )}

      <div className={`${styles.container} container-${props.id}`}>
        <div className={`${styles.wrapper} wrapper-${props.id}`}>
          {props &&
            typeof props.linkGPS != "undefined" &&
            typeof props.vendorFullAdress != "undefined" && (
              <a
                href={String(props.linkGPS?.value ?? props.linkGPS)}
                target="_blank"
                className={`${styles.link} link-${props.id} ${styles.hedden} hedden-${props.id}`}
                rel="noreferrer"
              >
                <PlatformsIcon
                  icon={"ep:location-information"}
                  className={`${styles.icon} icon-${props.id}`}
                />
                {String(
                  props.vendorFullAdress?.value ?? props.vendorFullAdress
                )}
              </a>
            )}

          {phoneStore1 && showPhone && (
            <Link
              href={`tel:+55${String(
                props.vendorPhone1?.value ?? props.vendorPhone1
              )
                .toString()
                .replace(/\D/g, "")}`}
              className={`${styles.link} link-${props.id} gtm_event_whatsapp`}
              data-umami-event="Ligar Agora"
            >
              <PlatformsIcon
                icon={"carbon:phone"}
                className={`${styles.icon} icon-${props.id}`}
              />
              {String(props.vendorPhone1?.value ?? props.vendorPhone1)}
            </Link>
          )}

          {whatsappStore1 && showWhatsapp && (
            <Link
              href={`https://wa.me/+55${String(
                props.vendorWhatsAppPhone1?.value ?? props.vendorWhatsAppPhone1
              ).replace(
                /\D/g,
                ""
              )}?text=→Oi%2C%20estou%20interessado%20em%20um%20ve%C3%ADculo%20que%20vi%20no%20seu%20site.%20Pode%20me%20fornecer%20mais%20informa%C3%A7%C3%B5es%3F`}
              className={`${styles.link} link-${props.id} gtm_event_whatsapp`}
              data-umami-event="Falar no Whatsapp"
            >
              <PlatformsIcon
                icon={"ic:baseline-whatsapp"}
                className={`${styles.icon} icon-${props.id}`}
              />
              Chamar no WhatsApp
            </Link>
          )}
        </div>
      </div>
    </>
  );
};
